import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import pr from "../lib/pr";
import { Button, Grid, TextField, Box } from "@mui/material";
import async from 'async';
import { useRecoilValue } from "recoil";
import { loginState } from "../lib/Store";
import Login from './Login';


const TestLogin = () => {
  return <Login></Login>;
}

export default TestLogin;
